module.exports = __webpack_public_path__ + "static/img/Team_spirit2.8eb6512.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Team_spirit2.png
// module id = xP45
// module chunks = 0